export default __webpack_public_path__ + "static/media/edit.ca2950c2.svg";